<template>
  <div v-if="item">
    <h6>ЗАПРОС #{{ item.id }}</h6>





    <fields-list :item="item" :fields="fields" />

     <div class="save-panel">
      <fg-input v-model="comment" placeholder="Ваш комментарий"/>
      <button class="btn btn-sm btn-success btn-icon mt-4" @click="updateItem">
        <span class="ti-save"></span>Сохранить
      </button>
    </div>



  </div>
</template>

<script>
import { cardUpdate, cardContent } from "../../../plugins/functions";

import FieldsList from "../FieldsList";

export default {
  data: () => ({
    cardLink: "scorings/card",
    cardSetLink: "scorings/update",
    smsNotify: "scorings/notify",
    item: null,
    comment: '',
    price: 0,
    fields: [
    
  
      {
        key: "customer",
        label: "Заказчик",
        type: "object",
        subFields: [
          {
            col: "col-md-6 col-12",
            key: "name",
            label: "Имя заказчкиа",
            type: "field",
            textType: "text",
          },
          {
            col: "col-md-6 col-12",
            key: "phone",
            label: "Контактный номер заказчика",
                type: "mask",
         mask: "+998#########",
          },
        ],
      },
      {
        key: "card",
        label: "Данные карты",
        type: "object",
        subFields: [
          {
            col: "col-md-8 col-12",
            key: "number",
            label: "Номер карты",
            type: "field",
            textType: "text",
          },
          {
            col: "col-md-4 col-12",
            key: "date",
            label: "Дата",
            type: "field",
            textType: "text",
          },
          {
            col: "col-md-6 col-12",
            key: "owner",
            label: "Владелец карты",
                type: "field",

          },
          {
            col: "col-md-6 col-12",
            key: "phone",
            label: "Телефон (привязана карта)",
                type: "mask",
         mask: "+998#########",
          },
        ],
      },
      {
        key: "passport",
        label: "Паспорт",
        type: "object",
        subFields: [
          {
            col: "col-md-4 col-12",
            key: "main",
            label: "Главное фото",
            type: "img",
            download: "download_main",
          },
          {
            col: "col-md-4 col-12",
            key: "location",
            label: "Прописка",
            type: "img",
            download: "download_location",
          },
          {
            col: "col-md-4 col-12",
            key: "selfie",
            label: "Селфи",
            type: "img",
            download: "download_selfie",
          },
        ],
      },
    
      {
        key: "comment",
        label: "Комментарий клиента",
        type: "textarea",
        readonly:true
      },
      {
        key: "feedback",
        label: "Вердикт",
        type: "textarea",
        readonly:true
      },
    ],
  }),
  components: {
    FieldsList,
  },
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async updateItem() {
        let item = await this.cardUpdate(this.cardSetLink, {...this.item, comment_from_admin:this.comment});
        if (item) {
          this.comment = '';
        }
    },
    async sendSMS() {
      await this.cardUpdate(this.smsNotify, this.item, "post");
    },
  },
  watch: {
    "item.receipt_type"(val) {
      for (let i = 0; i < this.fields.length; i++) {
        if (
          this.fields[i].key === "address" ||
          this.fields[i].key === "delivery"
        ) {
          if (val == 1) {
            this.fields[i].ishide = true;
          } else if (val == 2) {
            this.fields[i].ishide = false;
          }
        }
        if (this.fields[i].key === "shop") {
          if (val == 1) {
            this.fields[i].ishide = false;
          } else if (val == 2) {
            this.fields[i].ishide = true;
          }
        }
      }
    },
  },
};
</script>
<style>
</style>
